module.exports = "https://static.zego.com/_next/static/images/breakdown-icon-8d36237dbde1dd710fb7e846aec3ea37.svg";